export const getApiHost = (): string => {
  const els = document.querySelectorAll(
    'script[src*="frontend/oidcconnector-client.bundle.js"]',
  );
  const scriptUrl = els[0].getAttribute('src');
  const u = new URL(scriptUrl);
  return u.origin;
};
